export default __webpack_public_path__ + "static/media/menu-white.4bcb9e1a.svg";